var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"demoDemographics"}},[_c('div',{attrs:{"slot":"top"},slot:"top"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('m-demo-select',{attrs:{"propDemoType":1}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e0c3f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoDemographics.vue
// module id = null
// module chunks = 